import { Component, inject, OnInit } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BreadcrumbService } from 'xng-breadcrumb';
import { IconsService } from 'src/app/shared/services/icons.service';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { Invoice } from 'src/app/models/invoice.model';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { applyBillingFilters } from 'src/app/shared/utils/billing-filter.utils';

@Component({
  selector: 'app-invoice-generic',
  template: `
    <div class="d-flex mb-4 mt-4">
      <div class="flex-fill">
        <h1>Facturación</h1>
      </div>
    </div>
    <div class="flex-fill">
      <div class="d-flex">
        <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
          <ul #sidebar app-nav-invoices [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
        </div>
        <div #pages class="flex-fill">
          <div class="d-flex">
            <div>
            </div>
            <div class="flex-fill">
              <app-filter-full
                [profile]="profile"
                [payload]="payload"
                [showLegalEntity]="true"
                (legalEntity)="loadInvoicesByLegalEntity($event)"
                [toDate]="toDate"
                [fromDate]="fromDate"
                (billsSettlement)="loadInvoicesBySettlement($event)"
                (billsBuilding)="loadInvoicesByBuilding($event)"
                (billsFloor)="loadInvoicesByFloor($event)"
                (billsUnit)="loadInvoicesByUnit($event)"
                (billsSort)="loadInvoicesSort($event)"
                (billsOrder)="loadInvoicesOrder($event)"
                (dateRange)="updateDate($event)"
                (clear)="clearFilter()"
              ></app-filter-full>
            </div>
            <div>
              <app-invoice-csv-export-button
                [filters]="payload"
                query="query_generic"
                fileName="facturas-cargadas"
                reportTitle="Reporte de facturas cargadas"
                [rows]="invoices"
                [disabled]="loading"
              ></app-invoice-csv-export-button>
              <button class="btn btn-lg btn-outline-pirmary text-primary border border-2 rounded-5 border-primary shadow" routerLink="/invoices/uploader">Generación masiva</button>
            </div>
          </div>
          <div class="flex-fill list-group rounded-5 shadow mt-4">
            <div class="list-group-item" *ngIf="invoices.length > 0">
              <table class="table table-sm">
                <thead class="thead-dark">
                  <tr class="">
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3"><strong># Recibo</strong></th>
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2"><strong>Folio</strong></th>
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2"><strong>Unidad</strong></th>
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2"><strong>Razón social</strong></th>
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2"><strong>Emitida</strong></th>
                    <th scope="col" class="bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"><strong>Tipo</strong></th>
                  </tr>
                </thead>
                <tbody>
                  <tr app-tr-invoices 
                    [invoice]="invoice"
                    *ngFor="let invoice of invoices | paginate: { itemsPerPage: payFilterPrefs.per_page, currentPage: p, totalItems: meta.total_entries }"
                  ></tr>
                  <!-- app-item-invoice-generic
                    [invoice]="invoice"
                  ></app-item-invoice-generic -->
                </tbody>
              </table>
            </div>
            <div class="list-group-item" *ngIf="invoices.length==0&&loading">
              <div class="text-center py-5">
                <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
                <p class="text-muted">Cargando...</p>
              </div>
            </div>
            <div class="list-group-item" *ngIf="invoices.length==0&&!loading">
              <div class="text-center py-5">
                <img src="/assets/images/empty-state.png" width="240px">
                <p class="text-muted">No se encontraron registros</p>
              </div>
            </div>
            <div class="list-group-item text-center pt-3">
              <pagination-controls
                (pageChange)="p = $event"
                (pageChange)="pageChanged($event)"
                previousLabel="Prev."
                nextLabel="Sig."
                screenReaderPaginationLabel="Pagination"
                screenReaderPageLabel="page"
              ></pagination-controls>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class InvoiceGenericComponent implements OnInit {
  invoices: Invoice[] = [];
  meta: any = {};
  profile: any = {};
  permissions: any = {};

  currentView: string = 'generic';

  loading: boolean = false;
  searchActive: boolean = false;

  searchBox: FormGroup = new FormGroup({});

  payload: any = {
    page: 1,
    per_page: 100,
    tipo: 5,
    created_at_since: '',
    created_at_to: '',
    sort: 'created_at',
    order: 'DESC'
  };

  p: number = 1;

  a = new Date();
  fromDate;
  toDate;

  payFilterPrefs: any = {};
  storageService = inject(StorageService);
  constructor(
    private store : SettlementsService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    public icons: IconsService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.payload.profile_id = this.profile.id;

    const adjustedDate = new Date(this.a.getFullYear(), this.a.getMonth(), this.a.getDate());
    const testDate = new Date(this.a.getFullYear(), 1, 15);
    const lastDay = new Date(testDate.getFullYear(), testDate.getMonth() + 1, 0);

    this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());
    //
    this.payload.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    this.payload.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;

    this.payFilterPrefs = this.storageService.getItem(STORAGE_KEYS.PAYFILTERSPREFS) ? this.storageService.getItem(STORAGE_KEYS.PAYFILTERSPREFS) : this.payload;
    this.payFilterPrefs.tipo = 5;
    this.payFilterPrefs.profile_id = this.profile.id;
    this.payload = { ...this.payFilterPrefs };
    this.p = this.payFilterPrefs.page;

    this.loadInvoices(this.payFilterPrefs);
  }

  ngOnInit(): void {
    // this.loadInvoices(this.payload);
    this.initForm();
  }

  initForm() {
    this.searchBox = this.fb.group({
      search: ['']
    })
  }

  updateDate(event: any) {
    this.fromDate = event.from;
    this.toDate = event.to;

    if (this.toDate && this.fromDate && (this.toDate.after(this.fromDate) || this.toDate.equals(this.fromDate))) {
      this.payload.page = this.p = 1;
      this.payload.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
      this.payload.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
      this.loadInvoices(this.payload);
    }
  }

  loadInvoices(payload: any) {
    this.loading = true;
    this.store.getInvoicesQueryGeneric(payload).subscribe({
      next: (invoices: any) => {
        this.invoices = invoices.data;
        this.meta = invoices.meta;
        this.loading = false;
      },
      error: (err: any) => {
        console.log(err.status);
        this.loading = false;
        this.invoices = [];
        if (err.status === 500) {
          // this.toastr.error('Ocurrió un error al obtener las facturas.', 'Error');
        }
      }
    });
  }

  loadInvoicesUuid(payload: any) {
    this.loading = true;
    this.store.getInvoicesQueryGenericUuid(payload).subscribe({
      next: (invoices: any) => {
        this.invoices = invoices.data;
        this.meta = invoices.meta;
        this.loading = false;
      },
      error: (err: any) => {
        console.log(err.status);
        this.loading = false;
        this.invoices = [];
        if (err.status === 500) {
          // this.toastr.error('Ocurrió un error al obtener las facturas.', 'Error');
        }
      }
    });
  }

  searchInvoices(event: any) {
    this.payload.page = 1;
    this.payload.uuid = this.searchBox.value.search;

    this.loadInvoicesUuid(this.payload);
  }

  updateFilter() {
    console.log('FILTER ==> ', this.fromDate, this.toDate);
    this.payload.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    this.payload.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
    console.log('PAYLOAD ==> ', this.payload);
    this.loadInvoices(this.payload);
  }

  loadInvoicesBySettlement(settlement_id: any) {
    this.payload = applyBillingFilters(this.payload, { settlement_id, legal_entity_id: this.payload.legal_entity_id });
    this.p = 1;
    this.loadInvoices(this.payload);
  }

  loadInvoicesByBuilding(building_id: any) {
    delete this.payload.floor_id;
    delete this.payload.unit_id;
    this.payload.building_id = building_id;
    this.payload.page = this.p = 1;
    this.loadInvoices(this.payload);
  }

  loadInvoicesByFloor(floor_id: any) {
    delete this.payload.unit_id;
    this.payload.floor_id = floor_id;
    this.payload.page = this.p = 1;
    this.loadInvoices(this.payload);
  }

  loadInvoicesByUnit(unit_id: any) {
    this.payload.unit_id = unit_id;
    this.payload.page = this.p = 1;
    this.loadInvoices(this.payload);
  }

  loadInvoicesByLegalEntity(id: number | null) {
    if (id === null) delete this.payload.legal_entity_id;
    else this.payload.legal_entity_id = id;
    this.payload.page = this.p = 1;
    this.loadInvoices(this.payload);
  }

  loadInvoicesSort(event: any) {
    console.log('SORT EVENT ==> ', event);
    this.payload.sort = event;
    // this.payload.order = event.order;
    // this.loadBills(this.payload);
    this.getCurrentFilter();
  }

  loadInvoicesOrder(event: any) {
    console.log('ORDER EVENT ==> ', event);
    this.payload.order = event;
    this.getCurrentFilter();
  }

  getCurrentFilter() {
    console.log('CURRENT FILTER ==> ', this.payload);
    let count = 0;
    this.route.queryParamMap.subscribe(params => {      
      if (count>0){return;}
      console.log('PARAMS ==> ', params);

      if (params.has('unidad')) {
        this.payload.unit_id = params.get('unidad');
        this.loadInvoicesByUnit(this.payload.unit_id);
        return;
      }

      if (params.has('piso')) {
        this.payload.floor_id = params.get('piso');
        this.loadInvoicesByFloor(this.payload.floor_id);
        return;
      }

      if (params.has('edificio')) {
        this.payload.building_id = params.get('edificio');
        this.loadInvoicesByBuilding(this.payload.building_id);
        return;
      }

      if (params.has('condominio')) {
        this.payload.settlement_id = params.get('condominio');
        this.loadInvoicesBySettlement(this.payload.settlement_id);
        return;
      }
      count++;
    });
  }

  clearFilter() {
    this.payload = applyBillingFilters(this.payload, {});
    this.p = 1;
    this.loadInvoices(this.payload);
  }

  pageChanged(event: any) {
    this.payload.page = event;
    this.loadInvoices(this.payload);
  }
}
